import { render, staticRenderFns } from "./ChatGreeting.vue?vue&type=template&id=0d49cba9&scoped=true"
import script from "./ChatGreeting.vue?vue&type=script&lang=js"
export * from "./ChatGreeting.vue?vue&type=script&lang=js"
import style0 from "./ChatGreeting.vue?vue&type=style&index=0&id=0d49cba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49cba9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
